class SmallSwiperSlider extends HTMLElement {
    constructor() {
        super();
        this.arrowPrev;
        this.arrowNext ;
        this.swiperHolder;
        this.colorSwatches;
        this.itemWrapper;
    }
    connectedCallback() {
        this.init();
    }

    init(){
        setTimeout(()=>{
            this.arrowPrev = this.querySelector('.swiper-button-prev');
            this.arrowNext = this.querySelector('.swiper-button-next');
            this.swiperHolder = this.querySelector('.swiper-small-slider__swiper');
            this.colorSwatches = this.querySelectorAll('.ProductItem__connected-colors-value');
            this.itemWrapper = this.closest('.ProductItem');

            this.initializeSwiper();
            this.initSwatch();

            if (this.colorSwatches.length < 5){
              this.classList.add('small-slider');
            }
        }, 500);
    }

    initSwatch(){
        this.colorSwatches.forEach(value=>{
            value.addEventListener('click', (e)=>{
                this.itemWrapper.querySelectorAll('.ProductItem__Image')[1].src = value.dataset.connectedproductimage;
                this.itemWrapper.querySelectorAll('.ProductItem__Image')[1].srcset = value.dataset.connectedproductimage;
   
    
                this.itemWrapper.querySelector('.ProductItem__Image--alternate').src = value.dataset.secondproductimage;
                this.itemWrapper.querySelector('.ProductItem__Image--alternate').srcset = value.dataset.secondproductimage;
                this.itemWrapper.querySelectorAll('a').forEach(link=>{
                    link.href = value.dataset.connectedprodurl;
                });
                this.itemWrapper.querySelector('.ProductItem__Title').innerHTML = value.dataset.connectedproductitle;
                this.itemWrapper.querySelector('.ProductItem__Price').innerHTML = value.dataset.connectedproductprice;
                this.itemWrapper.querySelectorAll('.ProductItem__connected-colors-value').forEach(swatch=>{
                    swatch.classList.remove('ProductItem__connected-colors-value--active');
                });
                value.classList.add('ProductItem__connected-colors-value--active');
            });
        });
    }
  
    initializeSwiper() {
        this.swiper = new Swiper(this.swiperHolder, {
              spaceBetween: 5,
              slidesPerGroup: 1,
              freeMode: true,
              slidesPerView: 'auto',
              navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev,
              },
              breakpoints: {
                768: {
                  spaceBetween: 10,
                },
              }
        });
    }
}

customElements.define('swiper-small-slider', SmallSwiperSlider);